import { PayrollSettingsQueryModel } from "@/lib/api/company/configuration/payrollModule/types";

export const defaultPayrollSettings : PayrollSettingsQueryModel = {
    subtractPPK: 'inCurrentMonth',
    includeBonusAToPremium: false,
    decemberSalaryBasedOnJanuaryParams: false,
    includeLeavesAndSickInRecords: false,
    calculateLeaveAndSickAmounts: false,
    accidentContributionRate: 1.67,
    sickLeaveMode: 'grossZus',
    variableComponentsFromHours: 'real',
    variableLeaveComponentsCalc: 'automatic',
    leaveSalaryPaymentTiming: 'endOfMonth',
    sickSalaryPaymentTiming: 'endOfMonth',
    absenceComponents: [],
}
